import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a487f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-container" }
const _hoisted_2 = {
  key: 0,
  class: "logo-container"
}
const _hoisted_3 = { class: "font-weight-black" }
const _hoisted_4 = {
  key: 1,
  class: "title font-weight-black"
}
const _hoisted_5 = { class: "toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "date-picker-container d-flex justify-center"
}
const _hoisted_7 = {
  key: 3,
  class: "action-button"
}
const _hoisted_8 = {
  key: 2,
  class: "avatar-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobileView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.title), 1)),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.dateFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_v_date_input, {
              modelValue: _ctx.selectedDateRange,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDateRange) = $event)),
                _ctx.emitSelectedDateRange
              ],
              label: _ctx.$t('i18n.datePickerLabel'),
              "ok-text": _ctx.$t('i18n.datePickerOk'),
              "cancel-text": _ctx.$t('i18n.datePickerCancel'),
              "min-width": "19em",
              multiple: "range",
              "hide-details": "auto",
              variant: "outlined",
              density: "compact",
              color: "black",
              "single-line": "",
              clearable: "",
              "clear-icon": "mdi-close-circle",
              max: _ctx.maxDate,
              "onClick:clear": _ctx.clearDateRange
            }, null, 8, ["modelValue", "label", "ok-text", "cancel-text", "max", "onUpdate:modelValue", "onClick:clear"]),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "start"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('i18n.datePicker')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobileView && _ctx.searchBar)
        ? (_openBlock(), _createBlock(_component_v_text_field, {
            key: 1,
            class: "search-bar",
            "min-width": "18em",
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.searchBarPlaceholder,
            onInput: _ctx.emitSearch,
            "append-inner-icon": "mdi-magnify",
            "hide-details": "",
            "single-line": "",
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "placeholder", "onInput"]))
        : _createCommentVNode("", true),
      (_ctx.isMobileView && _ctx.searchBar)
        ? (_openBlock(), _createBlock(_component_v_text_field, {
            key: 2,
            class: "search-bar",
            "min-width": "19em",
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.searchBarPlaceholder,
            onInput: _ctx.emitSearch,
            "append-inner-icon": "mdi-magnify",
            "hide-details": "",
            "single-line": "",
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "placeholder", "onInput"]))
        : _createCommentVNode("", true),
      (_ctx.button)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_v_btn, {
              class: "gorate-btn-bg",
              rounded: "xl",
              variant: "flat",
              onClick: _ctx.handleNavBarClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMobileView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_UserAvatar)
        ]))
      : _createCommentVNode("", true)
  ]))
}